module.exports = tripManagement;